import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { App as AntApp, ConfigProvider, Spin, theme } from "antd";
import trTR from 'antd/locale/tr_TR'; // Ant Design component'lerini Türkçeleştirmek için

import Login from "./Login";
import Register from "./Register";
import MainLayout from "./MainLayout";
import { ThemeProvider, ThemeContext } from "./context/ThemeContext";
import { BranchProvider } from "./context/BranchContext";
import { FavoritesProvider } from "./context/FavoritesContext";
import { routes } from "./routes";

const isAuthenticated = () => !!localStorage.getItem("user");

function RequireAuth({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
}

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spin size="large" tip="Yükleniyor..." />
  </div>
);

export default function App() {
  return (
    <ThemeProvider>
      <ThemeContext.Consumer>
        {({ isDark, themeTokens }) => (
          <ConfigProvider
            locale={trTR}
            theme={{
              algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
              components: {
                Message: {
                  contentBg: isDark ? '#1f1f1f' : '#fff',
                  colorText: isDark ? '#fff' : '#000',
                },
                Notification: {
                  colorBgElevated: isDark ? '#1f1f1f' : '#fff',
                  colorText: isDark ? '#fff' : '#000',
                },
              },
            }}
          >
            <BranchProvider>
              <AntApp>
                <Router>
                  <Routes>
                    {/* Public Routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />

                    {/* Protected Routes - MainLayout içinde nested routing */}
                    <Route
                      path="/*"
                      element={
                        <RequireAuth>
                          <FavoritesProvider>
                            <Suspense fallback={<LoadingFallback />}>
                              <MainLayout />
                            </Suspense>
                          </FavoritesProvider>
                        </RequireAuth>
                      }
                    />

                    {/* Fallback route */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Router>
              </AntApp>
            </BranchProvider>
          </ConfigProvider>
        )}
      </ThemeContext.Consumer>
    </ThemeProvider>
  );
}
